import React, { useEffect } from "react";
import ModuleHeader from "../modules/ModuleHeader";
import { useClearCurrentTopic } from "../../hooks/useClearCurrentTopic";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { logEvent, logInteractionEvent } from "../../utils/appInsight";
import { trackAdobeClick } from "../../utils/adobeLogging";
import Card from "../common/Card";
import makeRequest from "../../utils/makeRequest";

const GenericPage = () => {
  const params = useParams();
  const section = useSelector((state) => state.progress.section);

  useEffect(() => {
    const trackHandler = (e) => {
      trackAdobeClick(null, {
        linkTitle: e.detail.link,
        linkModule: `${section}-${params.contentKey}-page`,
        targetURL: e.detail.link,
      });
      logEvent({
        name: "LinkFollowed",
        properties: {
          section,
          link: e.detail.link,
        },
      });
      logInteractionEvent("LinkFollowed", {
        section,
        link: e.detail.link,
      });
      makeRequest("post", `/api/servicebus/learn-more`, { url: e.detail.link });
    };

    window.addEventListener("track", trackHandler);

    return () => {
      window.removeEventListener("track", trackHandler);
    };
  }, []);

  useClearCurrentTopic();
  const page = useSelector((state) => state.pages[params.contentKey]);

  const getContent = () => {
    return { __html: page ? page.fullContent : "" };
  };

  return (
    <div adoberegion={`${section}-${params.contentKey}`}>
      <ModuleHeader
        title={page.data && page.data.title ? page.data.title : page.title}
      />
      <div className="generic-page lg:px-0 px-3">
        <Card>{page && <div dangerouslySetInnerHTML={getContent()} />}</Card>
      </div>
    </div>
  );
};

export default GenericPage;
